import { Component } from '@angular/core';
import { ICellRendererParams } from 'ag-grid-community';
import { PermissionService } from 'src/app/services/permission.service';

@Component({
    selector: 'app-provider-actions',
    templateUrl: './provider-actions.component.html',
    styleUrls: ['./provider-actions.component.css']
})
export class ProviderActionsComponent {
    public cellValue!: any;

    constructor(private permissionService: PermissionService) { }

    agInit(params: ICellRendererParams): void {
        this.cellValue = params;
    }

    refresh(params: ICellRendererParams): boolean {
        this.cellValue = params;
        return true;
    }

    canDo(module: string, action: string): boolean {
        return this.permissionService.canDo(module, action);
    }

    get providerId(): number {
        return this.cellValue?.data?.id;
    }

    get providerName(): string {
        const data = this.cellValue?.data;
        return data?.trade_name || data?.business_name || '';
    }
}
